
<form #shareWithForm="ngForm">
    <div class="w-full flex md:flex-col">
        <div class="mb-2">
            <p-floatlabel variant="in">
                <input pInputText type="email" required name="shareWithEmail" id="shareEmail" [(ngModel)]="shareWithEmail" email fluid />
                <label for="sharedEmail">{{'fields.email' | translate}}</label>
            </p-floatlabel>
        </div>

        <div class="mb-2">
            <p-floatlabel variant="in">
                <p-select id="privilegesSelect" required name="privileges" [options]="privileges" [(ngModel)]="accessLevel" optionLabel="label" optionValue="value" fluid />
                <label for="privilegesSelect">{{'fields.privileges' | translate}}</label>
            </p-floatlabel>
        </div>
        
        <button pButton [disabled]="!(shareWithForm.valid)" (click)="addUser()">{{'projects.shared.button' | translate}}</button>
    </div>    
</form>

<p-divider></p-divider>

<p class="font-bold">{{ 'fields.shared_W' | translate }}</p>
@if(project?.shared_w.length > 0) {
    @for (user of project.shared_w; track user) {
        <p-chip class="font-light mb-2 me-2 !py-0 !pl-0 !pr-4" [removable]="true" (onRemove)="removeAccess(user._id, 'shared_w')">
            <span class="bg-primary text-primary-contrast rounded-full w-8 h-8 flex items-center justify-center">
                {{user.name[0]}}
            </span>
            <span class="ml-2 font-small">
                {{user.name}} ({{user.email}})
            </span>
        </p-chip>
    }
}
@else {
    <p>{{ 'projects.shared.not-shared' | translate }}</p>
}

<p-divider></p-divider>

<p class="font-bold">{{ 'fields.shared_R' | translate }}</p>
@if(project?.shared_r.length > 0) {
    @for (user of project.shared_r; track user) {
        <p-chip class="font-light mb-2 me-2 !py-0 !pl-0 !pr-4" [removable]="true" (onRemove)="removeAccess(user._id, 'shared_r')">
            <span class="bg-primary text-primary-contrast rounded-full w-8 h-8 flex items-center justify-center">
                {{user.name[0]}}
            </span>
            <span class="ml-2 font-small">
                {{user.name}} ({{user.email}})
            </span>
        </p-chip>
    }
}
@else {
    <p>{{ 'projects.shared.not-shared' | translate }}</p>
}


